@if (mode == 'menu') {
  <button nbButton status="control" [matMenuTriggerFor]="menu">
    <tui-icon icon="ellipsis-vertical"/>
  </button>

  <mat-menu #menu="matMenu">
    @for (action of actions; track action; let i = $index) {
      <a mat-menu-item
         [attr.href]="action.href"
         [attr.target]="action.target"
         [nbSpinner]="loadingActions.has(i)"
         nbSpinnerStatus="primary"
         nbSpinnerSize="tiny"
         [class.is-loading]="loadingActions.has(i)"
         (click)="onActionClick(action, i)">
        <tui-icon [icon]="action.icon"/>
        {{ action.title }}
      </a>
    }
  </mat-menu>

} @else {
  @for (action of actions; track action; let i = $index) {
    <a [attr.href]="action.href"
       [attr.target]="action.target"
       [nbSpinner]="loadingActions.has(i)"
       nbSpinnerStatus="primary"
       nbSpinnerSize="tiny"
       [class.is-loading]="loadingActions.has(i)"
       (click)="onActionClick(action, i)"
       [nbTooltip]="action.title"
    >
      <tui-icon [icon]="action.icon"/>
    </a>
  }
}
